import { isEmpty } from 'lodash';
import {
  MEDIA_TYPES,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
} from '../../constants';

export const transformMediaQuestionAttributes = (options) => {
  const {
    image_url: imageURL,
    optimized_image_url: optimisedImageURL,
    video,
    media,
    refId,
    questionRefId,
  } = options;
  const isEmptyMedia = isEmpty(media);
  let type;
  let source;
  let thumbnail;
  let mediaQuestionRefId;
  let disableControl = false;
  if (imageURL) {
    type = MEDIA_TYPE_IMAGE;
    source = imageURL;
    thumbnail = optimisedImageURL || imageURL;
    mediaQuestionRefId = questionRefId;
  } else if (video) {
    type = MEDIA_TYPE_VIDEO;
    source = video.src;
    thumbnail = video.poster;
    ({ disableControl } = video);
    mediaQuestionRefId = questionRefId;
  } else if (!isEmptyMedia && MEDIA_TYPES.includes(media.type)) {
    source = media.url;
    ({ type, thumbnail, disableControl } = media);
    mediaQuestionRefId = questionRefId;
  }
  return {
    type,
    source,
    thumbnail,
    mediaQuestionRefId,
    disableControl,
    refId,
  };
};
